import React, { useState, useEffect } from 'react';
import { userEndpoint, Base_URL } from '../actions/API_endpoint';

const Team = () => {
    const [executiveTeam, setExecutiveTeam] = useState([]);
    const [supportingTeam, setSupportingTeam] = useState([]);

    useEffect(() => {
        const fetchMembers = async () => {
            try {
                const response = await fetch(`${Base_URL}${userEndpoint.getAllMembers}`);
                const data = await response.json();
                if (data.success) {
                    const execs = data.data.filter(m => m.type === 'executive team');
                    const supports = data.data.filter(m => m.type === 'supporting team');

                    setExecutiveTeam(execs);
                    setSupportingTeam(supports);
                }
            } catch (error) {
                console.error("Error fetching team members:", error);
            }
        };

        fetchMembers();
    }, []);

    const getImageUrl = (imageName) => {
        if (!imageName) return "https://via.placeholder.com/300x400?text=Team+Member";
        return `${process.env.REACT_APP_API_URL || Base_URL}/uploads/${imageName}`;
    };

    return (
        <section className="py-24 bg-dark-secondary">
            <div className="container mx-auto px-4">
                <div className="text-center mb-16">
                    <h2 className="text-4xl font-extrabold text-white mb-4">Meet Our <span className="text-nvcti-orange">Team</span></h2>
                    <p className="text-gray-400 max-w-2xl mx-auto text-lg">
                        The dedicated minds behind NVCTI driving innovation and excellence.
                    </p>
                </div>

                <div className="border border-white/10 rounded-3xl p-8 md:p-12 bg-white/5 backdrop-blur-sm relative">
                    <div className="text-center mb-10">
                        <h3 className="text-2xl md:text-3xl font-bold text-white inline-block border-b-2 border-nvcti-orange pb-2 uppercase tracking-wider">Executive Team</h3>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 justify-items-center">
                        {executiveTeam.map((member, index) => (
                            <div key={member.id || index} className="bg-dark-tertiary rounded-3xl shadow-2xl overflow-hidden w-full max-w-sm hover:shadow-accent-primary/20 transition-all duration-300 border border-white/5 group">
                                <div className="h-72 overflow-hidden bg-white/5 relative">
                                    <img
                                        src={getImageUrl(member.image_url)}
                                        alt={member.name}
                                        className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                                        onError={(e) => { e.target.src = "https://via.placeholder.com/300x400?text=Team+Member"; }}
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-dark-tertiary via-transparent to-transparent opacity-60"></div>
                                </div>
                                <div className="p-8 text-center relative">
                                    <h3 className="text-2xl font-bold text-white mb-1">{member.name}</h3>
                                    <p className="text-accent-primary font-bold mb-4 uppercase tracking-wider text-sm">{member.designation}</p>
                                    {member.email && (
                                        <a
                                            href={`mailto:${member.email}`}
                                            className="inline-flex items-center gap-2 text-gray-500 hover:text-white transition-colors py-2 px-4 rounded-full bg-white/5 hover:bg-white/10"
                                        >
                                            <span className="text-xs">📧</span> {member.email}
                                        </a>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="border border-white/10 rounded-3xl p-8 md:p-12 bg-white/5 backdrop-blur-sm relative mt-16">
                    <div className="text-center mb-10">
                        <h3 className="text-2xl md:text-3xl font-bold text-white inline-block border-b-2 border-nvcti-orange pb-2 uppercase tracking-wider">Supporting Team</h3>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 justify-items-center">
                        {supportingTeam.map((member, index) => (
                            <div key={member.id || index} className="bg-dark-tertiary rounded-3xl shadow-2xl overflow-hidden w-full max-w-sm hover:shadow-accent-primary/20 transition-all duration-300 border border-white/5 group">
                                <div className="h-72 overflow-hidden bg-white/5 relative">
                                    <img
                                        src={getImageUrl(member.image_url)}
                                        alt={member.name}
                                        className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                                        onError={(e) => { e.target.src = "https://via.placeholder.com/300x400?text=Team+Member"; }}
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-dark-tertiary via-transparent to-transparent opacity-60"></div>
                                </div>
                                <div className="p-8 text-center relative">
                                    <h3 className="text-2xl font-bold text-white mb-1">{member.name}</h3>
                                    <p className="text-accent-primary font-bold mb-4 uppercase tracking-wider text-sm">{member.designation}</p>
                                    {member.email && (
                                        <a
                                            href={`mailto:${member.email}`}
                                            className="inline-flex items-center gap-2 text-gray-500 hover:text-white transition-colors py-2 px-4 rounded-full bg-white/5 hover:bg-white/10"
                                        >
                                            <span className="text-xs">📧</span> {member.email}
                                        </a>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Team;
